export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/cover_letters.237e331.svg";